export default (parent, child) => {
  let node = child.parentNode;
  if (parent === child) {
    return true;
  }
  while (node !== null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/utils/isDescendant.js